import { PlannerGroupType } from '@ece-models/planner-group-type.enum';

export default class PlannerGroupResponse {
  /**
   * plannerGroupId string($uuid)
   * nullable: true
   */
  plannerGroupId: string;

  /**
   * groupName string
   * maxLength: 250
   * nullable: true
   */
  groupName?: string;

  /**
   * blockDescription string
   * maxLength: 15
   * nullable: true
   */
  blockDescription?: string;

  /**
   * icon string
   * maxLength: 50
   * nullable: true
   */
  icon?: string;

  /**
   * groupType: string(enum)
   */
  groupType: PlannerGroupType;

  /**
   * skillArea string
   * nullable: true
   */
  skillArea?: string;

  /**
   * weight integer($int32)
   */
  weight: number;
}
